function setShipDate() {
  // element to write date to
  var shipdate = document.getElementById("js-ship-date");

  // Set dates considering noOfDaysToAdd
  var startDate = new Date();

  var endDate = "",
    noOfDaysToAdd = document.getElementById("noOfDaysToAdd").innerHTML,
    count = 0;

  var holidays = [
    [2025, 01, 01], //New Year's Day Observed
    [2025, 01, 20], //Martin Luther King Jr. Day
    [2025, 02, 17], //Presidents Day
    [2025, 05, 26], //Memorial Day
    [2025, 06, 19], //Juneteenth National Independence Day Observed
    [2025, 07, 04], //Independence Day
    [2025, 09, 01], //Labor Day
    [2025, 10, 13], //Indigenous Peoples Day
    [2025, 11, 11], //Veterans Day
    [2025, 11, 27], //Thanksgiving
    [2025, 12, 25], //Christmas Day
    [2026, 01, 01], //New Year's Day

    [2025, 05, 12], //Closed
    [2025, 05, 13], //Closed
    [2025, 05, 14], //Closed
    [2025, 05, 15], //Closed
    [2025, 05, 16], //Closed
    [2025, 05, 19], //Closed
    [2025, 05, 20], //Closed
    
    [2025, 07, 03], //Closed
    [2025, 07, 08], //Closed
    [2025, 07, 09], //Closed
    [2025, 07, 10], //Closed
    [2025, 07, 11], //Closed
    [2025, 07, 14], //Closed
    [2025, 07, 15], //Closed

    [2025, 11, 26], //Closed
    [2025, 11, 28], //Closed

    [2025, 12, 23], //Closed
    [2025, 12, 24], //Closed
    [2025, 12, 26], //Closed
    [2025, 12, 29], //Closed
    [2025, 12, 30], //Closed
    [2025, 12, 31], //Closed
    
    [2026, 01, 02], //Closed
    [2026, 01, 05], //Closed
    
  ];

  // Numeric to written months
  var month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Check if there are personal/holidays
  function isHoliday(endDate) {
    var year = endDate.getFullYear(),
      month = endDate.getMonth(),
      day = endDate.getDate();

    return holidays.some(function (d) {
      return d[0] == year && d[1] == month + 1 && d[2] == day;
    });
  }

  // Loop
  while (count < noOfDaysToAdd) {
    // add a day to the end date each loop
    endDate = new Date(startDate.setDate(startDate.getDate() + 1));

    // only count when if it's a working day (exclude weekends and personal/holidays)
    if (endDate.getDay() != 0 && endDate.getDay() != 6 && !isHoliday(endDate)) {
      count++;
    }
  }

  // update shipdate HTML
  shipdate.innerHTML = month[endDate.getMonth()] + " " + endDate.getDate();
}

document.onreadystatechange = function () {
  if (document.readyState == "interactive") {
    setShipDate();
  }
};
